import { discountsSelector, calculateOrderSummary } from 'order-summary'
import { RENEWAL_FORM_NAME } from './constants'
import { createSelector } from 'reselect'

export const getMembershipRenewalOrderSummary = createSelector(
  (_, props) => props.membershipPlan.price,
  discountsSelector(RENEWAL_FORM_NAME),
  (price, discounts) => calculateOrderSummary(price, discounts)
)
